<ng-container *transloco="let t">
  @let customFieldsValue = customFields();

  @if (customFieldsValue && customFieldsValue.length > 0) {
    @for (customField of customFieldsValue; track customField.name; let index = $index) {
      <app-custom-field
        [customField]="customField"
        [value]="customFieldDetailValues()[index]"
        (valueChange)="onUpdateCustomFieldDetailValue(index, $event)"
        [displayErrors]="isFormSubmitted()"
      />
    }
  }
</ng-container>
